module.exports = __webpack_public_path__ + "static/media/SearchDuo.cd2f405d.svg";